import React from "react";
import { Sparkles } from "lucide-react";

export default function StickyMobileCall() {
  const scrollTo = () =>
    document.getElementById("ajanlat")?.scrollIntoView({ behavior: "smooth" });

  return (
    <button
      onClick={scrollTo}
      data-testid="sticky-mobile-call"
      aria-label="Árajánlatot kérek"
      className="md:hidden fixed bottom-5 right-5 z-50 pulse-call bg-[#1E47A8] text-white rounded-full px-5 py-4 flex items-center gap-2 text-xs uppercase tracking-[0.25em] font-medium"
    >
      <Sparkles size={16} className="text-[#D4B47A]" />
      Árajánlat
    </button>
  );
}
